import { fromJS } from 'immutable';
import { combineReducers } from 'redux';
import getApiReducer from '../common/utils/getApiReducer';

import {
  ADD_TV_SHOW,
  ADD_TV_EPISODE,
  ADD_VIDEO_TO_EPISODE,
  DELETE_TV_SHOW,
  EDIT_TV_SHOW,
  EDIT_TV_EPISODE,
  FETCH_TV_SHOWS,
  FETCH_TV_EPISODES,
  GET_TV_EPISODE_VIDEO,
  UPLOAD_TV_EPISODE_VIDEO,
  UPLOAD_TV_EPISODE_VIDEO_PROGRESS,
} from './actions';

const showsReducer = getApiReducer(FETCH_TV_SHOWS);
const shows = (state, action) => {
  state = showsReducer(state, action);

  if (action.type === `${EDIT_TV_SHOW}_SUCCESS`) {
    const data = state.get('data');
    const index = data.findIndex(item => item.get('id') === action.json.id);

    state = state.set('data', data.set(index, fromJS(action.json)));
  }

  if (action.type === `${DELETE_TV_SHOW}_SUCCESS`) {
    const data = state.get('data');
    const index = data.findIndex(item => item.get('id') === action.id);

    state = state.set('data', data.delete(index));
  }

  if (action.type === `${ADD_TV_SHOW}_SUCCESS`) {
    state = state.set('data', state.get('data').push(fromJS(action.json)));
  }

  return state;
};

const episodesReducer = getApiReducer(FETCH_TV_EPISODES);
const episodes = (state, action) => {
  state = episodesReducer(state, action);

  if (action.type === `${EDIT_TV_EPISODE}_SUCCESS` || action.type === `${ADD_VIDEO_TO_EPISODE}_SUCCESS`) {
    const data = state.get('data');
    const index = data.findIndex(item => item.get('id') === action.json.id);

    state = state.set('data', data.set(index, fromJS(action.json)));
  }

  if (action.type === `${GET_TV_EPISODE_VIDEO}_SUCCESS`) {
    const index = state.get('data').findIndex(item => item.get('id') === parseInt(action.episodeId, 10));

    state = state.setIn(['data', index, 'video'], fromJS(action.json));
  }

  if (action.type === `${ADD_TV_EPISODE}_SUCCESS`) {
    state = state.set('data', state.get('data').push(fromJS(action.json)));
  }

  return state;
};

const episodeUploadProgress = (state = { loaded: 0, total: 100 }, action) => {
  if (action.type === UPLOAD_TV_EPISODE_VIDEO_PROGRESS) {
    state = { loaded: action.loaded, total: action.total };
  }
  return state;
};

const episodeUploading = (state = false, action) => {
  if (action.type === UPLOAD_TV_EPISODE_VIDEO) {
    state = action.uploading;
  }
  return state;
};

export default combineReducers({
  episodes,
  episodeUploading,
  episodeUploadProgress,
  shows,
});



// WEBPACK FOOTER //
// ./src/tv/reducers.js